export type AcknowledgeEvent = { nativeEvent: { ack?: Function } }
export type ExtendedMouseEvent = React.MouseEvent<HTMLElement> & AcknowledgeEvent
export const acknowledgeEvent = (e: React.MouseEvent<HTMLElement>) => {
  if (e && (e as ExtendedMouseEvent).nativeEvent && (e as ExtendedMouseEvent).nativeEvent.ack) {
    (e as ExtendedMouseEvent).nativeEvent.ack!(e.currentTarget)
  }
}
